import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";

// sass
import "@/assets/scss/index.scss";

import "vant/lib/index.css";
import {
  Popup,
  Form,
  Field,
  Button,
  Tab,
  Tabs,
  Sticky,
  Dialog,
  Notify,
  Icon,
  NavBar,
  Step,
  Steps,
  Loading,
  Lazyload,
  Checkbox,
  CheckboxGroup,
} from "vant";
const app = createApp(App);
app
  .use(Form)
  .use(Popup)
  .use(Field)
  .use(Button)
  .use(Tab)
  .use(Tabs)
  .use(Sticky)
  .use(Dialog)
  .use(Notify)
  .use(Icon)
  .use(NavBar)
  .use(Step)
  .use(Steps)
  .use(Loading)
  .use(Checkbox)
  .use(CheckboxGroup)
  .use(Lazyload, {
    lazyComponent: true,
  });
app.use(router);
app.use(store);
app.mount("#app");
